export enum RSInputType {
  SELECT = "select",
  TOGGLE = "toggle",
  SORTED_LIST = "sorted-list",
}

// sync backend

export type ReportSettings = {
  findingsDisplayMode?: RSFindingsDisplayMode;
  findingsTableDisplayedColumns?: RSFindingsColumns[];
  findingsTableIncludeImages?: boolean;
  findingsTableDisplayedInfo?: RSFindingsColumns[];
  findingsListDisplayedInfo?: RSFindingsColumns[];
  findingsListIncludeImages?: boolean;
  findingsSplitTablesDisplayedInfo?: RSFindingsColumns[];
  overviewsPlacement?: RSOverviewsPlacement;
  findingsViewsDisplayMode?: RSViewsDisplayMode;
  imagesCaptionValues?: RSImagesCaptionValues[];
  appendicesImagesPerPage?: RSImagesPerPage;
};

export enum RSImagesPerPage {
  TWO = "2",
  FOUR = "4",
}

export enum RSFindingsDisplayMode {
  TABLE = "table",
  LIST = "list",
  SPLIT_TABLES = "splitTables",
}

export enum RSOverviewsPlacement {
  FINDINGS = "findings",
  VIEWS_SECTION = "viewsSection",
}

export enum RSViewsDisplayMode {
  INLINE = "inline",
  REFERENCE = "reference",
}

export enum RSFindingsColumns {
  DEFAULT_NUMBERING = "defaultNumbering",
  NAME = "name",
  COMMENT = "comment",
  NOTATION = "notation",
  SECURITY = "security",
  EVOLUTION = "evolution",
  IMAGE_NUMBERING = "imageNumbering",
  LOCATION = "location",
}

export enum RSImagesCaptionValues {
  NUMBERING = "numbering",
  DESCRIPTION = "description",
  LOCATION = "location",
}

export const defaultReportSettings: ReportSettings = {
  findingsDisplayMode: RSFindingsDisplayMode.TABLE,
  findingsTableDisplayedColumns: [
    RSFindingsColumns.DEFAULT_NUMBERING,
    RSFindingsColumns.NAME,
    RSFindingsColumns.COMMENT,
    RSFindingsColumns.NOTATION,
    RSFindingsColumns.SECURITY,
    RSFindingsColumns.EVOLUTION,
    RSFindingsColumns.IMAGE_NUMBERING,
  ],
  findingsTableIncludeImages: false,
  findingsTableDisplayedInfo: [
    RSFindingsColumns.COMMENT,
    RSFindingsColumns.IMAGE_NUMBERING,
  ],
  findingsListDisplayedInfo: [
    RSFindingsColumns.DEFAULT_NUMBERING,
    RSFindingsColumns.NAME,
    RSFindingsColumns.COMMENT,
    RSFindingsColumns.NOTATION,
    RSFindingsColumns.SECURITY,
    RSFindingsColumns.EVOLUTION,
    RSFindingsColumns.IMAGE_NUMBERING,
  ],
  findingsListIncludeImages: false,
  findingsSplitTablesDisplayedInfo: [
    RSFindingsColumns.DEFAULT_NUMBERING,
    RSFindingsColumns.NAME,
    RSFindingsColumns.COMMENT,
    RSFindingsColumns.NOTATION,
    RSFindingsColumns.SECURITY,
    RSFindingsColumns.EVOLUTION,
  ],
  overviewsPlacement: RSOverviewsPlacement.FINDINGS,
  findingsViewsDisplayMode: RSViewsDisplayMode.INLINE,
  imagesCaptionValues: [
    RSImagesCaptionValues.NUMBERING,
    RSImagesCaptionValues.DESCRIPTION,
  ],
  appendicesImagesPerPage: RSImagesPerPage.TWO,
};
